globalThis.ImageModalOpener = (function()
{
  function ImageModalOpener() {
    this.init();
  }

  ImageModalOpener.prototype = {
    init: function() {
      this.events();
    },
    events: function() {
      $('body').on('click', '.image-modal-opener', function(e)
      {
        var $target = $(e.target);

        if($target.hasClass('skip-modal-opener') || $target.closest('.skip-modal-opener').length) return null;


        var $this  = $(this),
            url    = $this.data('image-url'),
            $modal = $('.image-modal'),
            width  = $this.data('image-width');

        if(url && $modal.length) {
          $img = $('<img/>', {
            src: url,
            class: 'img-responsive'
          }).load(function() {
            $modal.find('.modal-dialog')
                  .css('max-width', (((width =  width || this.naturalWidth) > 600 ? 600 : width) + 30));

            if(!$this.data('image-width')) $this.data('image-width', width);
          }).appendTo($modal.find('.modal-body').empty());

          $modal.modal('show');
        }
        return false;
      });
    }
  }

  return ImageModalOpener;
})();
